import DesignServicesIcon from "@mui/icons-material/DesignServices";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";

const data = [
  {
    id: 1,
    icon: <DesignServicesIcon style={{ fontSize: "50px", color: "#DC965A" }} />,
    name: "01. RESPONSIVE LAYOUT",
    head: "Responsive layout design meeting clients needs.",
    details: "Your website will be responsive in any devices and User-Friendly",
  },
  {
    id: 2,
    icon: <DeveloperModeIcon style={{ fontSize: "50px", color: "#DC965A" }} />,
    name: "02. DEVELOPMENT",
    head: "Development gorgeous graphic design meeting clients needs.",
    details: `My service offers exquisite graphic design solutions tailored to meet client's unique needs, creating stunning visuals that captivate and communicate effectively..`,
  },

  {
    id: 3,
    icon: (
      <AutoAwesomeMosaicIcon style={{ fontSize: "50px", color: "#DC965A" }} />
    ),
    name: "03. GRAPHIC",
    head: "Graphic gorgeous design meeting clients needs.",
    details:
      "My service provides aesthetically stunning graphic design that is meticulously crafted to align perfectly with our clients' specific requirements, ensuring a visually captivating and tailored experience.",
  },

  {
    id: 4,
    icon: <FormatPaintIcon style={{ fontSize: "50px", color: "#DC965A" }} />,
    name: "04. WEB DESIGN",
    head: "Web Design gorgeous graphic design meeting clients needs.",
    details:
      "My service offers exceptional web design with a focus on exquisite graphic elements, combining functionality and creativity to meet and exceed our clients' diverse online needs, resulting in visually stunning and user-friendly websites",
  },

  {
    id: 5,
    icon: (
      <AutoAwesomeMotionIcon style={{ fontSize: "50px", color: "#DC965A" }} />
    ),
    name: "05. MOTION GRAPHY",
    head: "Motion Graphy design meeting clients needs.",
    details:
      "My service delivers dynamic web motion graphics design that perfectly caters to clients' requirements, enhancing their online presence with captivating and interactive visual experiences.",
  },

  {
    id: 6,
    icon: <PhotoCameraIcon style={{ fontSize: "50px", color: "#DC965A" }} />,
    name: "06. PHOTOGRAPHY",
    head: "Photography design meeting clients needs.",
    details:
      "My service provides photography-focused web design solutions that cater to clients' specific needs, creating visually engaging websites to showcase their work and captivate their online audience.",
  },
];

export default data;
